"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _leva = require("leva");
var _reactRedux = require("react-redux");
var _AmbientLight = _interopRequireDefault(require("./AmbientLight"));
var _DirectionalLight = _interopRequireDefault(require("./DirectionalLight"));
var _selectors = require("../../../redux/selectors");
var _HemisphereLight = _interopRequireDefault(require("./HemisphereLight"));
var _constants = require("../../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const Lights = () => {
  const [showGlobalLightHelper, setShowGlobalLightHelper] = (0, _react.useState)(false);
  const debugModeStatus = (0, _reactRedux.useSelector)(_selectors.getDebugModeStatus);
  const activeTheme = (0, _reactRedux.useSelector)(_selectors.getPackageTheme);
  const theme = _constants.themeSettings[activeTheme];
  const {
    lights_helper
  } = (0, _leva.useControls)('Lights', {
    lights_helper: showGlobalLightHelper
  });
  (0, _react.useEffect)(() => {
    setShowGlobalLightHelper(lights_helper);
  }, [lights_helper]);

  // const configSoftShadow = {
  // frustum: .75,
  // size: 0.5,
  // near: 9.5,
  // samples: 17,
  // rings: 11, // Rings (default: 11) must be a int
  // }
  // useEffect(() => {
  //     // Inject soft shadow shader
  //     softShadows(configSoftShadow)
  // }, [configSoftShadow])

  const debug = {
    showGlobalLightHelper,
    debugModeStatus
  };
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_AmbientLight.default, {
    color: theme.ambientLight.color,
    intensity: theme.ambientLight.intensity,
    debug: _objectSpread(_objectSpread({}, debug), {}, {
      name: 'Lights.Ambient Light'
    })
  }), /*#__PURE__*/_react.default.createElement(_HemisphereLight.default, _extends({}, theme.hemisphereLight, {
    debug: _objectSpread(_objectSpread({}, debug), {}, {
      name: 'Lights.Hemisphere Light.1'
    })
  })), /*#__PURE__*/_react.default.createElement(_DirectionalLight.default, _extends({}, theme.directionalLight, {
    debug: _objectSpread(_objectSpread({}, debug), {}, {
      name: 'Lights.Directional Light.1'
    })
  }))), [debug, theme]);
};
var _default = exports.default = Lights;